import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Icon, Typography, Button, Scrollbar } from '@ann/web-components';
import { 
    GranteesListContainerInternal, 
    GranteesListContainerExternal, 
    GranteeItem, 
    GranteeInfo, 
    GranteeActions,
    CollapsibleContainer, 
    CollapsibleHeader, 
    HeaderContent, 
    IconContainer 
} from '../Modal.styled';
import { NameInitialsAvatar } from 'react-name-initials-avatar';

const CurrentAgentsList = observer(({
    shouldShow,
    agents,
    isLoading,
    onRemove
}) => {
    const [isOpen, setIsOpen] = useState(false);

    if (!shouldShow) return null;

    return (
        <CollapsibleContainer>
            <CollapsibleHeader onClick={() => setIsOpen(!isOpen)}>
                <HeaderContent>
                    <Typography category="subtitle" size="small" weight="bold" color="subtitle">
                        View who has access
                    </Typography>
                    <Typography category="body" size="medium" weight="regular" color="body">
                        {agents.length} agents currently have access
                    </Typography>
                </HeaderContent>
                <IconContainer>
                    <Icon
                        name={isOpen ? "chevronUp" : "chevronDown"}
                        size={24}
                        color="secondary"
                    />
                </IconContainer>
            </CollapsibleHeader>

            {isOpen && (
                <GranteesListContainerExternal>
                    <Scrollbar size="small">
                        <GranteesListContainerInternal>
                            {isLoading ? (
                                <Typography category="body" size="medium" color="secondary">
                                    Loading...
                                </Typography>
                            ) : agents.length === 0 ? (
                                <Typography category="body" size="medium" color="secondary">
                                    No agents have access yet
                                </Typography>
                            ) : (
                                agents.map((agent) => (
                                    <GranteeItem key={agent.uuid}>
                                        <GranteeInfo>
                                            <NameInitialsAvatar
                                                name={agent.name}
                                                bgColor="#2563eb"
                                                textColor="#ffffff"
                                                size="24px"
                                                borderRadius="50%"
                                                textWeight="bold"
                                                textSize="18px"
                                                borderColor="#ffffff"
                                                borderStyle="solid"
                                                borderWidth="2px"
                                            />
                                            <Typography
                                                category="body"
                                                size="medium"
                                                weight="regular"
                                                color="body"
                                            >
                                                {agent.name}
                                            </Typography>
                                        </GranteeInfo>
                                        <GranteeActions>
                                            <Button
                                                icon="close"
                                                size="medium"
                                                type="tertiary"
                                                onClick={() => onRemove(agent.uuid)}
                                            />
                                        </GranteeActions>
                                    </GranteeItem>
                                ))
                            )}
                        </GranteesListContainerInternal>
                    </Scrollbar>
                </GranteesListContainerExternal>
            )}
        </CollapsibleContainer>
    );
});

export default CurrentAgentsList;
